<template>
    <div class="scroll-container" id="app-root" @scroll="handleScroll">
        <slot></slot>
    </div>
</template>

<script setup>
const handleScroll = (event) => {
    const container = event.target
    // 确保我们获取的是实际的滚动位置
    const scrollTop = Math.max(container.scrollTop, document.documentElement.scrollTop)
    window.dispatchEvent(new CustomEvent('containerScroll', {
        detail: {
            scrollTop: scrollTop
        }
    }))
}
</script>

<style scoped lang="scss">
.scroll-container {
    position: relative;
    overflow: auto;
    height: calc(100vh);
    scroll-behavior: smooth;

    // 确保内部内容不会创建新的滚动容器
    > * {
        overflow: visible;
        height: auto;
    }
}
</style> 